var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowcaseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.7325020432472229, -1.1719989776611328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 104.263 20.378 L 102.835 18.95 C 100.101 16.216 95.669 16.216 92.935 18.95 L 42.95 68.935 C 40.216 71.669 40.216 76.101 42.95 78.835 L 44.378 80.263 C 47.112 82.997 51.544 82.997 54.278 80.263 L 104.263 30.278 C 106.997 27.544 106.997 23.112 104.263 20.378 Z",
    fill: "#0012FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.965 64.891 L 95.536 63.462 C 92.803 60.729 88.371 60.729 85.637 63.462 L 61.546 87.554 C 58.812 90.287 58.812 94.719 61.546 97.453 L 62.974 98.881 C 65.708 101.615 70.14 101.615 72.874 98.881 L 96.965 74.79 C 99.698 72.057 99.698 67.624 96.965 64.891 Z",
    fill: "#E7FF06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115.585 83.509 L 114.157 82.081 C 111.423 79.347 106.991 79.347 104.257 82.081 L 54.272 132.066 C 51.538 134.8 51.538 139.232 54.272 141.966 L 55.7 143.394 C 58.434 146.128 62.866 146.128 65.6 143.394 L 115.585 93.409 C 118.319 90.675 118.319 86.243 115.585 83.509 Z",
    fill: "#974BF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseIcon);
export default __webpack_public_path__ + "static/media/ShowcaseIcon.15c70661.svg";
export { ForwardRef as ReactComponent };